const langPackLocalVersion = 42;export default langPackLocalVersion;
